import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <main className='flex h-dvh max-w-full overflow-hidden'>
            {children}
        </main>
    )
}
